export default {
  state: {
    unreadNum: 0,
    unreadList: ['', '', '', '', '']
  },
  mutations: {
    'GET_UNREAD_MESSAGES_NUM' (state, unreadNum) {
      state.unreadNum = unreadNum
    },
    'INIT_UNREADLIST' (state) {
      state.unreadList = ['', '', '', '', '']
    },
    'GET_MESSAGE_CONTENT' (state, { messageCont, index }) {
      let unreadListNew = []
      if (state.unreadList.length) {
        state.unreadList.map((item, i) => {
          if (i === index) {
            unreadListNew.push(messageCont)
          } else {
            unreadListNew.push(item)
          }
        })
      }
      state.unreadList = unreadListNew
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/message.js